<ng-content></ng-content>
<option *ngFor="let item of pledgeStatus" [value]="item.value">{{item.key}}</option>